export default (latitude?: number, longitude?: number) => {
  if (!latitude || !longitude) return;

  return encodeURI(`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`);
};
